export const HamburgerSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="27"
      height="17"
      viewBox="0 0 27 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.70264 1.9873H25.7959"
        stroke="#3E4685"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.70056 8.9873H25.7878"
        stroke="#3E4685"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.70355 15.9873H25.7867"
        stroke="#3E4685"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
